import { LandingFooter } from "@/components/landing/LandingFooter";
import {
  CLOSING_BAND,
  CLOSING_BAND_JOINED,
  Container,
  ContourField,
  CtaLink,
  Section,
} from "@/components/landing/primitives";
import { localePath, makeTr, type LandingLocale } from "@/lib/landing/locale";
import { PLANS } from "@/lib/pricing/plans";
import { cn } from "@/lib/utils";

/**
 * The closing ask and the footer on the guide pages: the landing page's
 * closing surface, with a sign-up and a link back to the product page.
 */
export function GuideClosing({
  locale,
  path,
  joined = false,
}: {
  locale: LandingLocale;
  path: string;
  /** The band above is tinted and runs on into this one (`tintedToClosing`). */
  joined?: boolean;
}) {
  const tr = makeTr(locale);
  const trialDays = PLANS[0].trialDays;
  return (
    <div
      className={cn(
        "relative isolate overflow-hidden",
        joined ? CLOSING_BAND_JOINED : CLOSING_BAND
      )}
    >
      <ContourField variant="closing" />
      <Section
        id="zacit"
        labelledBy="cta-title"
        tone="none"
        glow="center"
        className="pb-16 sm:pb-20"
      >
        <Container className="flex flex-col items-center text-center">
          <h2
            id="cta-title"
            className="max-w-2xl text-3xl font-semibold leading-[1.1] tracking-tight sm:text-5xl"
          >
            {tr("Ať se platby párují samy", "Let your payments match themselves")}
          </h2>
          <p className="mt-5 max-w-xl text-base leading-relaxed text-muted-foreground sm:text-lg">
            {trialDays
              ? tr(
                  `Připojte Fio účet a doklady k platbám najde Zettl. Prvních ${trialDays} dní zdarma, bez platební karty.`,
                  `Connect your Fio account and Zettl finds the documents for your payments. The first ${trialDays} days are free, no card needed.`
                )
              : tr(
                  "Připojte Fio účet a doklady k platbám najde Zettl.",
                  "Connect your Fio account and Zettl finds the documents for your payments."
                )}
          </p>
          <div className="mt-9 flex w-full flex-col justify-center gap-3 sm:w-auto sm:flex-row">
            <CtaLink
              to={localePath(locale, "/auth?tab=register")}
              className="h-12 px-7 text-base"
              arrow
            >
              {tr("Získat Zettl", "Get Zettl")}
            </CtaLink>
            <CtaLink to={localePath(locale, "/")} variant="outline" className="h-12 px-7 text-base">
              {tr("Jak Zettl funguje", "How Zettl works")}
            </CtaLink>
          </div>
        </Container>
      </Section>
      <LandingFooter locale={locale} path={path} />
    </div>
  );
}
